{
  "close": "Chiudi",
  "notifications": "{count, plural, one {# notifica} other {# notifiche}}."
}
